
/*
    Container for displaying the list of users within the PCS Portal app,
    which can be expanded for editing (only one at a time can be open)

    there's also a filter to choose which records to display,
    and a form for adding a new user
*/

import React, {useContext} from "react";

import DataContext from "../DataContext";
import MainContext from "../MainContext";

import UserManagementFilter from "../Filters/UserManagementFilter";
import UserData from "../DataDisplay/UserData";
import UserManagementForm from "../Forms/UserManagementForm";

import SubNav from "../Components/SubNav";
import SingleOpenList from "../Components/SingleOpenList";
import VerticalLayout from "../Components/VerticalLayout";

import * as UserRequests from "../Requests/UserRequests";

import { addElement, replaceElement, deleteElement } from "../Scripts/Utilities";

//
// wrapper component to make sure that we can immediately reload the data when that value is changed within the DatContext
//
const UserManagementPageContainer = (props) => {
    const context = useContext(DataContext);

    console.log("User Management ALL context", context);

    return (
        <UserManagementPage {...props}
            dataReload={context.dataReload}
            setReload={context.setReload}
        />
    )
};

export default UserManagementPageContainer;

class UserManagementPage extends React.Component {

    static contextType = MainContext;

    state = {
        addUserFormOpen: false,
        filterValues: {},
        users: [],
        closeAll: false
    };

    //
    //
    toggleAddUserForm = () => {
        if(this.state.addUserFormOpen){
            this.setState({addUserFormOpen: false});
        }
        else{
            this.context.toggleFilter(null, false);
            this.setState({addUserFormOpen: true});
        }
    }

    //
    //
    closeForms = (callback) => {
        this.context.toggleFilter(null, false);
        this.setState({addUserFormOpen: false, closeAll: true}, () => {
            this.setState({closeAll: false});
            if(callback && typeof callback === 'function'){
                callback();
            }
        });
    }

    //
    //
    applyFilter = (values, callback) => {
        this.setState({filterValues: values}, () => {
            this.getData(callback);
        });
    }

    //
    //
    getData = (callback) => {
        const request = () => UserRequests.getUsers(this.state.filterValues);
        const then = ({data}) => {
            console.log("GET USERS?", data);
            this.setState({users: data}, () => {
                if(callback && typeof callback === "function"){
                    callback();
                }
            })
        };

        this.context.runProcessing(request, then, "getUsers");
    }

    //
    // either the filter is open and we need to make sure to close the add use form
    // or else we're reloading the data
    //
    componentDidUpdate() {
        if(this.context.filterOpen && this.state.addUserFormOpen){
            this.setState({addUserFormOpen: false});
        }
        else if(this.props.dataReload){
            this.props.setReload(false, () => {                
                this.getData();
            });
        }        
    }

    //
    //
    addUser = (user) => {
        //
        // and also obviously need to make a call out to the API
        //

        const request = () => UserRequests.addUser(user);
        const then = ({data}) => {
            console.log("USER ADDED?", data);
            // ...
            if(data){
                this.setState({
                    users: addElement(this.state.users, data),
                    addUserFormOpen: false
                });

                this.closeForms(() => {
                    this.context.sendNotification(false, `New user created: ${user.username}`);
                })
            }
            else{
                this.context.sendNotification(true, `Create new user failed, please try again`);
            }
        }
        this.context.runProcessing(request, then, "addUser");
    }

    //
    //
    updateUser = (newUser, index) => {

        console.log("UPDATE USER ON PAGE LEVEL", newUser, index);

        const request = () => UserRequests.updateUser(newUser);
        const then = ({data}) => {
            console.log("USER UPDATE DATA", data);
            // ...
            if(data){
                this.setState({
                    users: replaceElement(this.state.users, data, index)
                });

                this.closeForms(() => {
                    this.context.sendNotification(false, `User Updated: ${newUser.username}`);
                })
            }
            else{
                this.context.sendNotification(true, `Update user failed, please try again`);
            }
        }
        this.context.runProcessing(request, then, "updateUser");
    }

    //
    //
    deleteUser = (index) => {
        const username = this.state.users[index].username;

        const proceed = window.confirm(`Are you sure you want to delete user: ${username}`);

        if(proceed){
            const request = () => UserRequests.deleteUser(username);
            const then = ({data}) => {
                // ...
                if(data){
                    this.setState({
                        users: deleteElement(this.state.users, index)
                    });

                    this.closeForms(() => {
                        this.context.sendNotification(false, `User Deleted: ${username}`);
                    })
                }
                else{
                    this.context.sendNotification(true, `Delete user failed, please try again`);
                }
            }
            this.context.runProcessing(request, then, "updateUser");
        }
    }

    render() {

        // const filterString = JSON.stringify(this.state.filterValues);

        return (
            <VerticalLayout firstHeight={this.state.addUserFormOpen ? 0 : 8}>
                {
                    // if the add user form is open, then don't display the option to open that form
                    this.state.addUserFormOpen
                    ? null
                    : <SubNav>
                        <div className="option  " onClick={this.toggleAddUserForm}>Add New User</div>
                    </SubNav>
                }
                <div className="content">
                    <>
                    {
                        // the filter
                        this.context.hasFilter
                        && this.context.filterOpen
                            ? <UserManagementFilter toggleFilter={this.context.toggleFilter} applyFilter={this.applyFilter} filterValues={this.state.filterValues} />
                            : null
                    }
                    {
                        // the add user form
                        this.state.addUserFormOpen
                        ? <div style={{
                            marginBottom: "12px"
                        }}>
                            <UserManagementForm submit={this.addUser} />
                        </div>
                        : null
                    }
                    <SingleOpenList 
                        data={this.state.users} 
                        component={UserData} 
                        forceClose={this.closeAll || this.context.filterOpen || this.state.addUserFormOpen}
                        prependCall={(mainFunc) => this.closeForms(mainFunc)}
                        props={{
                            selectedList: this.state.selectedTrips
                            , onSelect: this.onSelect
                            , updateUser: this.updateUser
                            , deleteUser: this.deleteUser
                        }} 
                    />
                    </>
                </div>
            </VerticalLayout>
        )
    }
}
